<template>
  <div class="nx-scrollytelling-slide-editor-preview">
    <iframe ref="iframe"
            :key="previewRefresherKey"
            :style="iframeStyle"
            :src="previewUrl"/>
    <nx-display-mode-selector
      @input="onDisplayModeChange"
      :currentMode="displayMode"
      :preview-url="previewUrl"
      :displayModes="displayModes"
      type="content"
    />
  </div>
</template>
<script>
import { displayModesContentEditor as displayConfig } from '@/modules/board/config';
import NxDisplayModeSelector from '@/components/buttons/DisplayModeSelector';
import { mapGetters } from 'vuex';

export default {
  name: 'nx-scrollytelling-slide-editor-preview',
  components: { NxDisplayModeSelector },
  props: {
    previewUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      displayMode: displayConfig.defaultDisplayMode,
      displayModes: displayConfig.displayModes,
    };
  },
  computed: {
    ...mapGetters('scrollytelling', [
      'previewRefresherKey',
    ]),
    selectedMode() {
      return this.displayModes[this.displayMode] || { width: '100%' };
    },
    iframeStyle() {
      return {
        'max-width': this.selectedMode.width,
      };
    },
  },
  methods: {
    reload() {
      this.$refs.iframe.src = this.previewUrl;
    },
    onDisplayModeChange(displayMode) {
      this.displayMode = displayMode;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/variables.styl'

.nx-scrollytelling-slide-editor-preview {
  display: flex
  background-color: #e9e9f2;
  iframe {
    background-color: $white
    margin: 0 auto
    border: 0
    width: 100%
    height: calc(100vh - 64px)
  }
}
</style>
